import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import TitleYellow from '../TitleYellow/TitleYellow';
import CustomAccordion from '../../Molecules/CustomAccordion/CustomAccordion';
import ButtonYellow from '../ButtonYellow/ButtonYellow';
import './TapsCourse.css';
import ModalPreviewCV from '../../Modals/ModalPreviewPDF/ModalPreviewPDF';
import Spinner from '../Spinner/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';


const TapStudyPlan = ({
  courseContentList,
  parametersCard,
  parametersContentCarrousel,
  setShowPDFBrochure,
  brochure = '',
  courseID,
  language
}) => {
  const languageDes = language?.description?.toLowerCase();
  return (
    <div className="w-100">
      <TitleYellow
        className="text-md-start text-center"
        fontSize="32px"
        title={parametersContentCarrousel?.INF_MSG_127?.value}
        titleYellow={parametersContentCarrousel?.INF_MSG_127?.description_value}
      />
      <CustomAccordion items={courseContentList} renderList={true} parameters={parametersCard} />
      {brochure !== '' && (
        <div className="w-100 text-lg-start text-center">
          <a
            href={`/${languageDes}/brochure-viewer?course=${courseID}`}
            target="_blank" // Esto hace que se abra en una nueva pestaña
            rel="noopener noreferrer" // Buena práctica de seguridad
            className="text-decoration-none" // Para que no se subraye si el botón tiene texto
          >
            <ButtonYellow
              className="button-yellow"
              title={
                <div className="btn-content d-flex align-items-center">
                  <span>{'Visualizar'}</span>
                  <div className="icon-container ps-3">
                    <FontAwesomeIcon icon={faDownload} />
                  </div>
                </div>
              }
            />
          </a>
        </div>
      )}
    </div>
  );
};

const TapsCourse = ({
  parametersContentCarrousel,
  parametersCard,
  parametersBrouchure,
  courseContentList,
  brochure = '',
  courseItem,
  changeView = false,
  previewClip,
  scrollToCourseCard = () => {},
  isMobile
}) => {
  const [showPDFBrochure, setShowPDFBrochure] = useState(false);

  const languageKey = useSelector((store) => store.languageTraslate.language)
  console.log("languageKey",languageKey)

  const handleTabSelect = (key) => {
    if (key === 'consultants') {
      scrollToCourseCard();
    }
  };

  return (
    <>
      <ModalPreviewCV
        show={showPDFBrochure}
        setShow={setShowPDFBrochure}
        pdfFile={{ file: brochure }}
        subtitle={parametersBrouchure?.BROCHURE_TXT?.description_value ?? <Spinner />}
        title={parametersBrouchure?.BROCHURE_TXT?.value}
        widthBtns="30%"
      />
      <div className="taps-container-course wrapper-tabs">
        {' '}
        <Tabs
          defaultActiveKey="about"
          id="fill-tab-example"
          className="course-taps custom-tabs mb-4"
          fill
          onSelect={handleTabSelect}>
          <Tab className="course-tap-item" eventKey="about" title={parametersCard?.ABOUT_AT?.value}>
            <div className="d-flex flex-column text-center">
              <TitleYellow
                fontSize="32px"
                title={parametersBrouchure?.BOOST_CAREER_LABEL?.value ?? 'Impulsamos tu'}
                titleYellow={
                  parametersBrouchure?.BOOST_CAREER_LABEL?.description_value ??
                  'carrera profesional'
                }
              />
              <Row>
                <Col lg={changeView ? 4 : 12}>
                  <div
                    className="d-flex justify-content-center align-items-center py-4"
                    style={{ borderRadius: '20%' }}>
                    <video
                      controls
                      autoPlay
                      playsInline
                      src={
                        previewClip?.length > 0 && previewClip !== ''
                          ? previewClip
                          : parametersCard?.YOUR_COMPANY_LT_VIDEO?.video
                      }
                      style={{ width: changeView ? '100%' : isMobile ? '90%' : '60%' }}
                      id="myVideoCourse"
                      onClick={(event) => event.stopPropagation()}></video>
                  </div>
                </Col>
                <Col lg={changeView ? 8 : 12}>
                  <p className="text-lg-start text-center">{courseItem?.short_description}</p>
                </Col>
              </Row>
            </div>
          </Tab>
          <Tab
            eventKey="brochure"
            title={parametersCard?.TAP_STUDY_PLAN?.value || 'Plan de estudio'}>
            <div className="d-flex flex-column text-start">
              <TapStudyPlan
                courseContentList={courseContentList}
                parametersCard={parametersCard}
                parametersContentCarrousel={parametersContentCarrousel}
                setShowPDFBrochure={setShowPDFBrochure}
                brochure={brochure}
                courseID={courseItem?.pk}
                language={languageKey}
              />
            </div>
          </Tab>
          <Tab
            eventKey="consultants"
            title={parametersCard?.TAP_OUR_CONSULTANTS?.value || 'Nuestros consultores'}>
            <div className="d-flex flex-column text-start">
              <TapStudyPlan
                courseContentList={courseContentList}
                parametersCard={parametersCard}
                parametersContentCarrousel={parametersContentCarrousel}
                setShowPDFBrochure={setShowPDFBrochure}
                brochure={brochure}
              />
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default TapsCourse;
